var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg29Cross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.308594,
    y: 0.114258,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5507 20.3568C20.811 20.0965 20.811 19.6744 20.5507 19.414L17.2513 16.1146L20.5516 12.8143C20.8119 12.554 20.8119 12.1319 20.5516 11.8715C20.2912 11.6112 19.8691 11.6112 19.6088 11.8715L16.3085 15.1718L13.0082 11.8715C12.7478 11.6112 12.3257 11.6112 12.0654 11.8715C11.805 12.1319 11.805 12.554 12.0654 12.8143L15.3657 16.1146L12.0663 19.414C11.8059 19.6744 11.8059 20.0965 12.0663 20.3568C12.3266 20.6172 12.7487 20.6172 13.0091 20.3568L16.3085 17.0574L19.6079 20.3568C19.8682 20.6172 20.2903 20.6172 20.5507 20.3568Z",
    fill: "#FF0101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg29Cross);
export default __webpack_public_path__ + "static/media/29_cross.95b0915a0351806cc948c7924057b7ee.svg";
export { ForwardRef as ReactComponent };